"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpAssessmentAnalysisHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var assessment_type_enum_1 = require("../../../../api/constants/assessment-type.enum");
var DpAssessmentAnalysisHeader_styled_1 = require("./DpAssessmentAnalysisHeader.styled");
var react_bootstrap_1 = require("react-bootstrap");
var api_1 = require("../../../../api");
var DpAssessmentAnalysisHeader = function (_a) {
    var _b;
    var type = _a.type, scoringType = _a.scoringType, openItemAnalysisModal = _a.openItemAnalysisModal, assessment = _a.assessment;
    // ------- Const
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var affirmWWAttemptAnalysis = ((_b = (0, api_1.getObjectFromLocalStorage)(api_1.LocalStorageKeys.AffirmFeatureFlags)) === null || _b === void 0 ? void 0 : _b.AffirmWWAttemptAnalysis) ||
        false;
    var analysisButtonClick = function () {
        openItemAnalysisModal(assessment.assessmentTemplate.items[0].externalId, assessment.assessmentTemplate.items[0].externalBankItemId, 0, scoringType);
    };
    var legend = type === assessment_type_enum_1.AssessmentType.Assessment
        ? t('assessmentAnalysis.legend')
        : t('assessmentAnalysis.vocabLegend');
    // ------- Render
    return ((0, jsx_runtime_1.jsxs)(DpAssessmentAnalysisHeader_styled_1.StyledAssessmentAnalysisHeader, { children: [(0, jsx_runtime_1.jsx)("div", { className: "title", children: openItemAnalysisModal && affirmWWAttemptAnalysis ? ((0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, { variant: "outline-primary", onClick: analysisButtonClick, children: t('assessmentAnalysis.title') })) : ((0, jsx_runtime_1.jsx)("h1", { className: "h4", children: t('assessmentAnalysis.title') })) }), (0, jsx_runtime_1.jsxs)("div", { className: "legend", children: [(0, jsx_runtime_1.jsx)("span", { className: "rounded-circle dot" }), (0, jsx_runtime_1.jsx)("span", { className: "text", children: legend })] })] }));
};
exports.DpAssessmentAnalysisHeader = DpAssessmentAnalysisHeader;
exports.default = exports.DpAssessmentAnalysisHeader;
